/**
 * Firebase client — single source of truth for `app`, `auth`, `db`, `analytics`.
 */
import { initializeApp, getApps } from "firebase/app";
import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  inMemoryPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";

// authDomain drives (a) the Auth SDK's iframe origin, and (b) the
// domain baked into password-reset / email-verification link URLs.
// Using our custom domain instead of the default `.firebaseapp.com`
// means reset emails read "acework.app/__/auth/action?..." — cleaner
// brand, and users don't get spooked by an unfamiliar domain in their
// mailbox. Firebase Hosting reserves /__/** paths and serves the
// built-in Auth UI at them automatically, even with our SPA `**`
// rewrite in firebase.json (reserved paths take precedence).
// Requirement: `acework.app` must be in Firebase Console →
// Authentication → Settings → Authorized domains.
const firebaseConfig = {
  apiKey: "AIzaSyC4AkCnlqHG9rO7-NynqGDA8eTZPyb8iF0",
  authDomain: "acework.app",
  projectId: "acework-tennis",
  storageBucket: "acework-tennis.firebasestorage.app",
  messagingSenderId: "796800035930",
  appId: "1:796800035930:web:4401a17ec778c534753c63",
  measurementId: "G-K3KX84XSRR",
};

export const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// initializeAuth (instead of getAuth) — without a popupRedirectResolver,
// Firebase doesn't load the gapi iframe, which breaks under Capacitor's
// `capacitor://` scheme. signInWithEmailAndPassword still works.
export const auth = initializeAuth(app, {
  persistence: [
    indexedDBLocalPersistence,
    browserLocalPersistence,
    inMemoryPersistence,
  ],
});

export const db = getFirestore(app, "default");

// Callable Cloud Functions — pin the region to match where we deployed
// (all our CFs live in us-central1).
export const functions = getFunctions(app, "us-central1");

export const analyticsPromise = (async () => {
  if (typeof window === "undefined") return null;
  try {
    return (await isAnalyticsSupported()) ? getAnalytics(app) : null;
  } catch {
    return null;
  }
})();
